/* eslint-disable import/no-cycle */
export const PERSIST_LAST_LANG_CODE = 'persistLastLangCode'
export const I18_NEXT_LNG = 'i18nextLng'
export const IS_EXTERNAL_PAYMENT_3P_EXCHANGE = 'isExternalPayment3pExchange'
